/**
 * Created by Stefano Mandruzzato on 21/03/18.
 */
export default function pecImportContainer ($log, _) {
      'ngInject'
      var logger = $log.getInstance('pecImportContainer');

      function link(scope, elem, attrs, parentCtrl) {
        logger.debug("link", arguments);
      }

      return {
        restrict: 'AE',
        controller: 'PecImportController',
        controllerAs: 'PecImportController',
        bindToController: true,
        scope: {
          email: '='
        },
        link: link,
        template: require('./pecImport.html')
      }
  };



// WEBPACK FOOTER //
// ./client/components/pec-import-container/pec-import.directive.js